import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css'; // This line is re-added to import the Tailwind CSS directives.

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
